import frontendLogger from "../utils/frontendLogger.js";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../app_config.js";
import "./css/App.css";

function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [recoveryCode, setRecoveryCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRecovery = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/forgotPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, recoveryCode }),
      });

      const data = await response.json();
      if (!response.ok) {
        setError(data.message || "Recovery fehlgeschlagen");
      } else {
        navigate("/resetPassword", {
          state: {
            userId: data.userId,
            recoveryId: data.recoveryId,
          },
        });
      }
    } catch (err) {
      frontendLogger.error("Recovery error:", err);
      setError("Serverfehler. Bitte später erneut versuchen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Passwort Recovery</h1>
        <h3>Digital Review and Aroma Manager</h3>

        <form onSubmit={handleRecovery}>
          <div className="form-group">
            <label>Benutzername</label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Benutzername eingeben"
              required
            />
          </div>

          <div className="form-group">
            <label>Recovery Code</label>
            <input
              value={recoveryCode}
              onChange={(e) => setRecoveryCode(e.target.value)}
              placeholder="Recovery Code eingeben"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
          <div className="login-nav">
            <button type="submit" disabled={loading}>
              {loading ? "Senden..." : "Senden"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
